/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friends_ListInputs */

const en_friends_list = /** @type {(inputs: Friends_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Friend households`)
};

const de_friends_list = /** @type {(inputs: Friends_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Befreundete Haushalte`)
};

/**
* | output |
* | --- |
* | "Friend households" |
*
* @param {Friends_ListInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friends_list = /** @type {((inputs?: Friends_ListInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friends_ListInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_friends_list(inputs)
	return en_friends_list(inputs)
});